import 'angular:locale/data:en-NL';
import 'zone.js';(globalThis.$localize ??= {}).locale = "en-NL";
